import { getApiBaseUrl } from "../../../config/runtimeConfig";

export const IDA_INTERNAL_DOWNLOAD_LINK_PREFIX =
  "/api/workspace/ida/documents/download-link/";

const LEGACY_APP_ORIGINS = new Set(["https://app.metalmind.ai"]);

const fallbackOrigin = "http://localhost";

function getBaseOrigin(): string {
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  return fallbackOrigin;
}

export function toInternalDownloadLinkEndpoint(href: string): string | null {
  if (!href) return null;
  if (href.startsWith("//")) return null;

  try {
    const apiOrigin = new URL(getApiBaseUrl()).origin;
    const url =
      href.startsWith("http://") || href.startsWith("https://")
        ? new URL(href)
        : new URL(href, getBaseOrigin());

    if (!url.pathname.startsWith(IDA_INTERNAL_DOWNLOAD_LINK_PREFIX)) {
      return null;
    }

    const trustedOrigins = new Set([
      getBaseOrigin(),
      apiOrigin,
      ...LEGACY_APP_ORIGINS,
    ]);
    if (!trustedOrigins.has(url.origin)) return null;

    // The backend's canonical contract is the path/query, not an origin. Chat
    // synthesis can render that relative path using the legacy production app
    // origin. Never navigate to that rendered origin: reduce a recognized route
    // from a trusted app/API origin back to the current authFetch endpoint.
    return `${url.pathname}${url.search}`;
  } catch {
    return null;
  }
}

export function isInternalDownloadLink(href: string): boolean {
  return toInternalDownloadLinkEndpoint(href) !== null;
}
